<template>
  <div class="avatar-sm" v-if="src">
    <img :src="src" class="avatar-img rounded-circle" />
  </div>          
  <div v-else>
    <span class="avatar bg-primary-gradient text-white rounded-circle">
      <span class="initials">
        {{ initial }}
      </span>
    </span>
  </div>            
</template>
<script>
export default {
  props: ['src', 'fallback'],

  computed: {
    initial() {
      return this.fallback.split('')[0]
    }
  }
}
</script>